import { observer } from "mobx-react-lite";
import React, { FC, useContext, useState } from "react";
import { Link } from "react-router-dom";
import { Context } from "..";
import UpdateUser from "./UpdateUser";

const Profile: FC = () => {
  const { store } = useContext(Context);
  let user = store.user;
  const [updated, setUpdated] = useState<boolean>(false);

  if (updated) {
    const inputs = document.querySelectorAll("input");
    inputs.forEach((input) => {
      if (input.value.trim() !== '') {
        input.parentElement?.classList.add("focus");
      }
    })
  }

  return (
    <div className="profile">
      <div className="text-center">
        {user.isActivatedMail ?
          user.isActivated ? <h2 className="profile__redirect"><a href="http://uptodate.phc.org.ua/go.php">Перейти у систему</a></h2> : <h2 className="profile__redirect profile__redirect--no">Вас ще не авторизував відповідальний працівник</h2>
          : <button className="profile__redirect" onClick={store.getActivationLink}>Відправити лист заново</button>
        }
      </div>
      <div className="profile__btns">
        <button className="profile__btn" onClick={() => setUpdated(true)}>Змінити профіль</button>
        {user.isAdmin ? <Link className="profile__btn" to="/all-users">Усі користувачі</Link> : ''}
      </div>
      {updated ? <UpdateUser user={user} /> : ''}
    </div>
  );
};

export default observer(Profile);
